import { Routes, Route, useLocation } from "react-router-dom";
import { pageTransition, pageVariants } from "../animations/routesAnimations";
import { AnimatePresence, motion } from "framer-motion";
import HomeHeader from "./HomeHeader";
import Header from "./Header";
import Home from "../pages/Home";

import { useTranslation } from "react-i18next";
import { Constants } from "../Constants";
import { bottomNavigationHeight } from "../styles/theme";
import { useEffect, lazy } from "react";
import { applicationInsights } from './ApplicationInsights';

const Account = lazy(() => import("../pages/Account"));
const Profile = lazy(() => import("../pages/Profile"));
const Language = lazy(() => import("../pages/Language"));
const Feedback = lazy(() => import("../pages/Feedback"));

const LacAiAgent = lazy(() => import("../pages/LacAiAgent"));
const DailyHuddleDocument = lazy(() => import("../pages/DailyHuddleDocument"));
const DailyHuddleFacilities = lazy(() => import("../pages/DailyHuddleFacilities"));

const AnimatedRoutes = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const motionDivStyle = {
    width: "100%",
    height: `calc(100% - ${bottomNavigationHeight})`,
    overflow: "auto",
  };

  useEffect(() => {
    // This effect runs every time the location object changes,
    // indicating a route change.
    const insights = applicationInsights.getInstance();
    if (insights) {
      insights.trackPageView({
        name: location.pathname,
        uri: location.pathname,
      });
    }
    // You can perform actions here based on the new route
  }, [location]);

  return (
    <AnimatePresence>
      <Routes location={location} key={location.pathname}>
        <Route
          path={Constants.navigation.urls.account}
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              style={motionDivStyle}
            >
              <Header
                title={t(Constants.translationKeys.header_title_account)}
              />
              <Account />
            </motion.div>
          }
        />
        <Route
          path={Constants.navigation.urls.profile}
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              style={motionDivStyle}
            >
              <Header
                title={t(Constants.translationKeys.header_title_profile)}
              />
              <Profile />
            </motion.div>
          }
        />
        <Route
          path={Constants.navigation.urls.language}
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              style={motionDivStyle}
            >
              <Header
                title={t(Constants.translationKeys.header_title_language)}
              />
              <Language />
            </motion.div>
          }
        />
        <Route
          path={Constants.navigation.urls.feedback}
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              style={motionDivStyle}
            >
              <Header
                title={t(Constants.translationKeys.header_title_feedback)}
              />
              <Feedback />
            </motion.div>
          }
        />
        <Route
          path={Constants.navigation.urls.home}
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              style={motionDivStyle}
            >
              <HomeHeader />
              <Home />
            </motion.div>
          }
        />
        <Route
          path={Constants.navigation.urls.dailyHuddleDocument}
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              style={motionDivStyle}
            >
              <Header title={t("daily_huddle_title")} />
              <DailyHuddleDocument />
            </motion.div>
          }
        />
        <Route
          path={Constants.navigation.urls.lacAiAgent}
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              style={{ ...motionDivStyle, display: "flex", flexDirection: "column", overflow: "hidden" }}
            >
              <Header title="Local Support Finder" />
              <LacAiAgent />
            </motion.div>
          }
        />
        <Route
          path={Constants.navigation.urls.dailyHuddleFacilities}
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              style={motionDivStyle}
            >
              <Header title={t("daily_huddle_title")} />
              <DailyHuddleFacilities />
            </motion.div>
          }
        />
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
